const SUBMENU_HIDE_MS = 240;
const SCROLL_HIDE_AFTER = 120;

const Header = {
  header: null,
  overlay: null,
  items: [],
  lastScrollTop: 0,

  getPanel: function (item) {
    const toggle = item.querySelector('[data-rd-submenu-toggle]');
    if (!toggle) return null;
    const id = toggle.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  },

  openSubmenu: function (item) {
    const { items, header, overlay } = Header;

    items.forEach(other => {
      if (other !== item) Header.closeSubmenu(other);
    });

    const panel = Header.getPanel(item);
    const toggle = item.querySelector('[data-rd-submenu-toggle]');
    if (!panel || !toggle) return;

    clearTimeout(panel.hideTimeout);
    clearTimeout(item.hoverTimeout);
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');

    // Sem transform no header: position:fixed do painel precisa do viewport.
    header.classList.remove('scroll-down', 'scroll-up');
    header.classList.add('has-submenu-open');
    if (overlay) overlay.classList.add('-visible');

    requestAnimationFrame(() => {
      item.classList.add('is-open');
      panel.classList.add('is-open');
    });
  },

  closeSubmenu: function (item) {
    const { header, overlay, items } = Header;

    const panel = Header.getPanel(item);
    const toggle = item.querySelector('[data-rd-submenu-toggle]');
    if (!panel || !toggle) return;

    clearTimeout(item.hoverTimeout);
    item.classList.remove('is-open');
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');

    clearTimeout(panel.hideTimeout);
    panel.hideTimeout = setTimeout(() => {
      panel.hidden = true;
    }, SUBMENU_HIDE_MS);

    const anyOpen = items.some(other => other.classList.contains('is-open'));
    if (!anyOpen) {
      header.classList.remove('has-submenu-open');
      if (overlay) overlay.classList.remove('-visible');
      Header.setScroll(window.pageYOffset);
    }
  },

  closeAll: function () {
    Header.items.forEach(item => Header.closeSubmenu(item));
  },

  // Painel fora do header: transform no scroll não quebra position:fixed.
  relocatePanels: function () {
    const { header, items } = Header;
    if (!header) return;

    items.forEach(item => {
      const panel = item.querySelector('[data-rd-submenu]');
      if (!panel || panel.dataset.rdRelocated === 'true') return;
      header.insertAdjacentElement('afterend', panel);
      panel.dataset.rdRelocated = 'true';
    });
  },

  handleSubmenus: function () {
    const { items } = Header;
    if (items.length === 0) return;

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    items.forEach(item => {
      const toggle = item.querySelector('[data-rd-submenu-toggle]');
      const panel = Header.getPanel(item);
      if (!toggle || !panel) return;

      // Clique no item principal: navega (link real). Só faz toggle se for
      // botão sem URL (#) — sem destino pra ir.
      toggle.addEventListener('click', event => {
        const isButton = toggle.tagName === 'BUTTON';
        const href = toggle.getAttribute('href');
        const hasDestination = href && href !== '#' && href !== '';

        if (!isButton && hasDestination) {
          // Deixa o browser seguir o link; fecha o painel pra não ficar preso.
          Header.closeAll();
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (item.classList.contains('is-open')) {
          Header.closeSubmenu(item);
        } else {
          Header.openSubmenu(item);
        }
      });

      if (!canHover) return;

      const openSoon = () => {
        clearTimeout(item.hoverTimeout);
        Header.openSubmenu(item);
      };

      const closeSoon = () => {
        clearTimeout(item.hoverTimeout);
        item.hoverTimeout = setTimeout(() => {
          Header.closeSubmenu(item);
        }, SUBMENU_HIDE_MS);
      };

      item.addEventListener('mouseenter', openSoon);
      item.addEventListener('mouseleave', closeSoon);
      panel.addEventListener('mouseenter', openSoon);
      panel.addEventListener('mouseleave', closeSoon);
    });

    document.addEventListener('click', event => {
      const openItem = items.find(item => item.classList.contains('is-open'));
      if (!openItem) return;

      const panel = Header.getPanel(openItem);
      const inItem = openItem.contains(event.target);
      const inPanel = panel && panel.contains(event.target);
      if (!inItem && !inPanel) Header.closeAll();
    });

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;

      const openItem = items.find(item => item.classList.contains('is-open'));
      if (!openItem) return;

      Header.closeSubmenu(openItem);
      const toggle = openItem.querySelector('[data-rd-submenu-toggle]');
      if (toggle) toggle.focus();
    });
  },

  setScroll: function (scrollTop) {
    const { header } = Header;
    if (header.classList.contains('has-submenu-open')) return;

    if (scrollTop <= 0) {
      header.classList.add('on-top');
      header.classList.remove('scroll-down', 'scroll-up');
      return;
    }

    header.classList.remove('on-top');

    if (scrollTop > Header.lastScrollTop && scrollTop > SCROLL_HIDE_AFTER) {
      header.classList.add('scroll-down');
      header.classList.remove('scroll-up');
    } else {
      header.classList.add('scroll-up');
      header.classList.remove('scroll-down');
    }
  },

  handleScroll: function () {
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset;
        Header.setScroll(scrollTop);
        Header.lastScrollTop = scrollTop;
        ticking = false;
      });
    }, { passive: true });
  },

  init: function () {
    Header.header = document.querySelector('[data-rd-header]');
    if (!Header.header) return;

    Header.overlay = document.getElementById('overlay');
    Header.items = [...Header.header.querySelectorAll('[data-rd-menu-item]')];
    Header.lastScrollTop = window.pageYOffset;

    Header.relocatePanels();
    Header.setScroll(Header.lastScrollTop);
    Header.handleSubmenus();
    Header.handleScroll();
  },
};

export default Header;
